/**
 * Pricing Constants
 * Single source of truth for VAT and deposit calculations
 */

export const VAT_RATE = 0.18
export const VAT_MULTIPLIER = 1.18
export const DEPOSIT_COEFF = 0.2542
